// src/SourceBadge.jsx — the order Source pill.
// One renderer for the Orders list and the reports that show a Source column
// (2026-09-22, Eric: "can I add a source column like we have in the primary
// order list too? … We can use the same styling"). Palette: Team Portal =
// blue, Retail = green, Add-On = amber; mixed sources keep that left-to-right
// order in the gradient.
import React from 'react';
import './orders-v2/orders-tanstack.css';

const TP = '#e3f2fd', RT = '#e8f5e9', AO = '#fff3e0';

export default function SourceBadge({ source, fallback = '—' }) {
    const src = (source || '').toLowerCase();
    if (src === 'team_portal') return <span className="ots-src-badge ots-src-badge--tp">Team Portal</span>;
    if (src === 'retail')      return <span className="ots-src-badge ots-src-badge--retail">Retail</span>;
    if (src === 'addon')       return <span className="ots-src-badge ots-src-badge--tp" style={{ background: AO }}>Add-On</span>;
    if (src === 'tp_retail')   return <span className="ots-src-badge ots-src-badge--tp" style={{ background: `linear-gradient(90deg, ${TP} 50%, ${RT} 50%)` }}>Team Portal/Retail</span>;
    if (src === 'tp_addon')    return <span className="ots-src-badge ots-src-badge--tp" style={{ background: `linear-gradient(90deg, ${TP} 50%, ${AO} 50%)` }}>Team Portal/Add-On</span>;
    if (src === 'retail_addon') return <span className="ots-src-badge ots-src-badge--tp" style={{ background: `linear-gradient(90deg, ${RT} 50%, ${AO} 50%)` }}>Retail/Add-On</span>;
    if (src === 'tp_retail_addon') return <span className="ots-src-badge ots-src-badge--tp" style={{ background: `linear-gradient(90deg, ${TP} 33%, ${RT} 33%, ${RT} 66%, ${AO} 66%)` }}>Team Portal/Retail/Add-On</span>;
    return <span className="ots-muted">{fallback}</span>;
}

// Plain-text label for CSV exports and tooltips.
export function sourceLabel(source) {
    return ({
        team_portal: 'Team Portal', retail: 'Retail', addon: 'Add-On',
        tp_retail: 'Team Portal/Retail', tp_addon: 'Team Portal/Add-On',
        retail_addon: 'Retail/Add-On', tp_retail_addon: 'Team Portal/Retail/Add-On',
    })[(source || '').toLowerCase()] || '';
}
